import {
  FAILED_REQUEST,
  LOADING_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  SET_HERE_ABOUT_US_STATUS,
  UPDATE_MODAL_STATUS,
} from "../constants";
import storePersist, { localConstant } from "../../../services/localStorage";
import apiConfig from "../../../services/apiManager/apiConfig";
import {
  postRequest,
  setHereAboutUsStatusRequest,
} from "../../../services/apiManager/apiRequests";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../../utils/snackbarConfig";

export const logout = () => async (dispatch) => {
  dispatch({
    type: LOGOUT_SUCCESS,
  });
};

export const UpdateModalState = (value) => async (dispatch) => {
  dispatch({
    type: UPDATE_MODAL_STATUS,
    payload: value,
  });
};

export const authenticateLogin =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: LOADING_REQUEST,
        payload: { isLoading: true },
      });
      const response = await postRequest(apiConfig.authLoginUser, params);

      if (response?.entity_id) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: response,
        });
        if (response?.entity_user_status !== "INACTIVE") {
          storePersist.set(
            localConstant.API_ACCESS_TOKEN,
            response?.access_token,
          );
          storePersist.set(
            localConstant.REFRESH_TOKEN,
            response?.refresh_token,
          );
          storePersist.set(localConstant.LOGIN_TIMESTAMP, new Date().getTime());
          storePersist.set(localConstant.USER_ID, response?.entity_id);
          storePersist.set(
            localConstant.ENTITY_CUSTOMER_ID,
            response?.entity_customer_id,
          );
          storePersist.set(
            localConstant.USER_PROFILE,
            response?.entity_role_code,
          );
          storePersist.set(
            localConstant.SUPER_ADMIN,
            response?.superAdmin || false,
          );
          storePersist.set(localConstant.USER_DATA, response);
          storePersist.set(
            localConstant.AGREEMENT_STATUS,
            response?.entity_agreement_status,
          );
          storePersist.set(
            localConstant.AGREEMENT_ID,
            response?.entity_agreement_id,
          );
        }
        callback(response);
      } else {
        enqueueSnackbar("Failed to login", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: FAILED_REQUEST,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.errMsg, {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: FAILED_REQUEST,
        payload: {},
      });
    }
  };

export const setStatusHereAboutUs =
  (body, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await setHereAboutUsStatusRequest(
        apiConfig.hereAboutUs,
        { ...body },
      );
      dispatch({
        type: SET_HERE_ABOUT_US_STATUS,
        payload: body?.userReferralSource,
      });
      callback();
    } catch (error) {
      dispatch({
        type: SET_HERE_ABOUT_US_STATUS,
        payload: "",
      });
      enqueueSnackbar("Error Updating hear about us status", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback();
    }
  };
